import { render, staticRenderFns } from "./BlackGoldSupportPage.vue?vue&type=template&id=5c41799b&"
import script from "./BlackGoldSupportPage.vue?vue&type=script&lang=js&"
export * from "./BlackGoldSupportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports